import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Cropper from '@src/components/Cropper';
import Breadcrumbs from '@src/components/Breadcrumbs';

import css from './style.module.scss';

const HeadBlock = (props) => {
	const { title, content, expandLabel, titleTag, adaptive, breadcrumbs } =
		props;
	const Title = titleTag;
	return (
		<div
			className={cn(css.block, {
				[css[`block_adapt_${adaptive}`]]: !!adaptive,
			})}
		>
			{breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
			{title && <Title className={css.title}>{title}</Title>}
			{content && (
				<div className={css.content}>
					<Cropper
						isArrow={false}
						isRightEdge
						expandLabel={expandLabel}
						cropHeight={5 * 24}
						expandElem={
							<div className={css.more}>{expandLabel}</div>
						}
					>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Cropper>
				</div>
			)}
		</div>
	);
};

HeadBlock.propTypes = {
	content: PropTypes.string,
	title: PropTypes.string,
	expandLabel: PropTypes.string,
	titleTag: PropTypes.elementType,
	breadcrumbs: PropTypes.shape(Breadcrumbs.type.propTypes),
	adaptive: PropTypes.oneOf(['default']),
};

HeadBlock.defaultProps = {
	content: undefined,
	title: undefined,
	breadcrumbs: undefined,
	expandLabel: t('еще'),
	titleTag: 'h1',
	adaptive: 'default',
};

export default HeadBlock;
